// A11Y: mirror the PDP "Adding product to your cart" feedback.
function announceQuickAdd(container) {
    var labelEl = container && container.querySelector('[data-quick-loader-label]');
    var label = ((labelEl && labelEl.textContent) || 'Adding product to your cart').trim();
    var region = document.getElementById('quick-add-live');
    if (!region) {
        region = document.createElement('div');
        region.id = 'quick-add-live';
        region.setAttribute('aria-live', 'assertive');
        region.setAttribute('aria-atomic', 'true');
        region.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0;';
        document.body.appendChild(region);
    }
    region.textContent = '';
    setTimeout(function () { region.textContent = label; }, 30);
}

class QuickView extends HTMLElement {
    constructor() {
        super();
        this.modal = document.querySelector('[data-quick-modal]');
        this.wrapper = this.modal.querySelector('[data-quick-container]');
        this.close = this.modal.querySelector('[data-quick-additional-close]');
        this.handle= this.dataset.quickOpen;
        this.addEventListener('click', this.onButtonClick.bind(this));
        this.modal.addEventListener('click', this.onModalClick.bind(this));
        this.close.addEventListener('click', this.onButtonCloseClick.bind(this));

        // A11Y: <quick-view> is a custom element - needs tabindex to be focusable.
        this.setAttribute('role', 'button');
        if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');
        this.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                e.preventDefault();
                this.onButtonClick(e);
            }
        });
        // Close on Escape and trap Tab focus within the dialog while open
        // (bound once per modal). Keyboard focus should stay inside the modal.
        if (this.modal && !this.modal.dataset.a11yModal) {
            this.modal.dataset.a11yModal = '1';
            document.addEventListener('keydown', (e) => {
                if (!this.modal.classList.contains('opened')) return;
                // If the Rebuy cart drawer is open (e.g. opened by add-to-cart from
                // within Quick View), let it own focus/keys instead of fighting it.
                if (document.querySelector('.rebuy-smart-cart.is-visible')) return;
                if (e.key === 'Escape') {
                    this.onButtonCloseClick();
                } else if (e.key === 'Tab') {
                    this.trapFocus(e);
                }
            });
        }
    }
    onButtonClick(event){

        event.preventDefault();
        // Remember the opener so focus can return to it when the modal closes.
        this.modal._opener = this;

        fetch(`/products/${this.handle}?section_id=js-quick-view`)
        .then(response => response.text()).then(data => {
          $(this.wrapper).html(data);
        }).then(()=>{
            this.modal.classList.add('opened');
            document.body.classList.add('rebuy-modal-visible');
        }).then(()=>{
            // Wrapped so an init error can't stop focus from moving into the modal.
            try { this.runScripts(); } catch (e) { console.warn('Quick view init error', e); }
        }).then(()=>{
            // Move focus into the dialog so keyboard users land inside it.
            this.moveFocusIn();
        }).catch((err) => {
            console.warn('Quick view error', err);
        });
    }

    getFocusable(){
        return Array.prototype.slice.call(this.modal.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((el) => el.offsetParent !== null);
    }

    moveFocusIn(){
        var self = this;
        // Defer a frame so the dialog's display/visibility have applied before we
        // focus (otherwise .focus() on a not-yet-shown element is ignored).
        requestAnimationFrame(function(){
            var focusable = self.getFocusable();
            var target = focusable[0] || self.close;
            if (target) target.focus();
        });
    }

    trapFocus(e){
        var focusable = this.getFocusable();
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        var active = document.activeElement;
        // If focus is outside the open modal (e.g. still on the page behind it),
        // pull it in on the next Tab instead of walking the page.
        if (!this.modal.contains(active)) {
            e.preventDefault();
            first.focus();
        } else if (e.shiftKey && active === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && active === last) {
            e.preventDefault();
            first.focus();
        }
    }

    onModalClick(event){
        if (!event.target.closest('.modal__dialog')) {
            this.modal.classList.remove('opened');
            document.body.classList.remove('rebuy-modal-visible');
            if (this.modal._opener) this.modal._opener.focus();
        }
    }

    onButtonCloseClick(){
        this.modal.classList.remove('opened');
        document.body.classList.remove('rebuy-modal-visible');
        if (this.modal._opener) this.modal._opener.focus();
    }

    runScripts(){
        // init gallerys
        const galleryThumbs = new Swiper('.quick-view-gallery-thumbs', {
            direction: 'vertical',
            slidesPerView: 4,
            spaceBetween: 10,
            loop: false,
                navigation: {
                nextEl: '.quick-view__swiper-button-next',
                prevEl: '.quick-view__swiper-button-prev',
            },
            // A11Y: makes the prev/next chevrons keyboard-focusable buttons.
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous product image thumbnails',
                nextSlideMessage: 'Next product image thumbnails',
                // A11Y: the thumbnail button already reads "Image X of Y";
                // blank the slide label so SR doesn't also read Swiper's "index / length".
                slideLabelMessage: '',
            },
        });

        const swiper = new Swiper("#mySwiperQuickWiew", {
            slidesPerView: "auto",
            thumbs: {
                swiper: galleryThumbs,
            },
        });
        galleryThumbs.controller.control = galleryThumbs;

        // A11Y: thumbnails are role="button" divs - Enter/Space activate, arrows move and activate, and the strip is one Tab stop (shared with the PDP).
        if (window.a11yThumbnails) {
            window.a11yThumbnails('.quick-view .product-single__thumbnail', function (index) {
                swiper.slideTo(index);
                galleryThumbs.slideTo(index);
            });
        }
       

        // init swatch
        const radios = document.querySelectorAll('.quick-view .swatch-element input[type="radio"]');
        
        radios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                const optionIndex = this.closest('.swatch').getAttribute('data-option-index');
                const optionValue = this.value;
                const form = this.closest('form');
                const singleOptionSelectors = form.querySelectorAll('.single-option-selector');

                if (singleOptionSelectors[optionIndex]) {
                    singleOptionSelectors[optionIndex].value = optionValue;
                    singleOptionSelectors[optionIndex].dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        });

        // A11Y: swatch radiogroup keyboard model, mirroring the PDP.
        document.querySelectorAll('.quick-view .flavor-dropdown--list[role="radiogroup"]').forEach(function (group) {
            group.addEventListener('keydown', function (e) {
                var groupRadios = Array.prototype.filter.call(
                    group.querySelectorAll('input[type="radio"]'),
                    function (r) { return !r.disabled; }
                );
                var idx = groupRadios.indexOf(document.activeElement);
                if (idx === -1) return;
                var swatch = group.closest('.swatch');
                var toggle = swatch ? swatch.querySelector('[role="button"]') : null;
                if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
                    e.preventDefault();
                    groupRadios[(idx + 1) % groupRadios.length].focus();
                } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
                    e.preventDefault();
                    groupRadios[(idx - 1 + groupRadios.length) % groupRadios.length].focus();
                } else if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                    e.preventDefault();
                    groupRadios[idx].click();
                    if (toggle) toggle.focus();
                } else if (e.key === 'Escape' || e.key === 'Esc') {
                    e.preventDefault();
                    // Stop the modal's document-level Escape handler from also firing:
                    // Escape here should only close the open flavor dropdown, not the
                    // whole Quick View modal. A second Escape (dropdown closed) still
                    // bubbles up and closes the modal.
                    e.stopPropagation();
                    if (toggle) { toggle.click(); toggle.focus(); }
                }
            });
        });


        // init variants
        const $container = $('.quick-view_inner');
        const options = {
            $container: $container,
            enableHistoryState: false,
            singleOptionSelector: '.single-option-selector-js-quick-view',
            originalSelectorId: '#ProductSelect-js-quick-view',
            product: JSON.parse(document.getElementById("ProductJson-js-quick-view").innerHTML),
        };
  
        const variants = new slate.Variants(options); 

        $container.on("variantChange",updateVariant);

        // Keep the button's price showing the line total (unit x qty) as the
        // shopper changes quantity by typing or via the +/- steppers. The steppers
        // are document-delegated (theme.js) and dispatch a "change" on the input.
        // Wrapped so jQuery's event object isn't passed as the variant argument.
        $container.find('[data-quantity-input]').on('input change', function () {
            updateAddToCartPrice();
        });

        // Current quantity as a positive integer (steppers can momentarily reach 0,
        // and the field can be cleared while typing); fall back to 1 for the price.
        function getQuickViewQuantity() {
            const $qty = $container.find('[data-quantity-input]');
            const qty = $qty.length ? parseInt($qty.val(), 10) : 1;
            return isNaN(qty) || qty < 1 ? 1 : qty;
        }

        // Render the add-to-cart button price = unit price x quantity for the
        // currently selected variant. Called on variant change and quantity change.
        // On variant change, slate.Variants fires "variantChange" before it updates
        // its own currentVariant, so the fresh variant is passed in explicitly; the
        // quantity handler calls with no argument and reads the settled currentVariant.
        function updateAddToCartPrice(variant) {
            variant = variant || variants.currentVariant;
            const addToCartButton = $container.find('[data-add-to-cart]');
            const addToCartButtonText = $container.find('[data-add-to-cart-text]');
            if (variant && variant.available) {
                addToCartButton.attr('disabled', false);
                const lineTotal = variant.price * getQuickViewQuantity();
                const formattedPrice = Shopify.formatMoney(lineTotal);
                // Match the server-rendered markup so styling (and the Transcy
                // currency wrapper) is preserved.
                addToCartButtonText.html(
                    'Add to cart <span class="font-light quick-view__button-money">' +
                    formattedPrice +
                    '</span>'
                );
                // A11Y: keep the accessible name in sync with the visible line
                // total (unit x qty). Money markup can carry currency-app
                // wrappers (e.g. Transcy); strip it for the accessible name.
                addToCartButton.attr(
                    'aria-label',
                    'Add to cart ' + formattedPrice.replace(/<[^>]*>/g, '')
                );
            } else {
                addToCartButton.attr('disabled', true);
                addToCartButtonText.html('Sold Out');
                addToCartButton.attr('aria-label', 'Sold Out');
            }
        }

        function updateVariant(data) {
            const variant = data.variant;

            // update images
            if(variant.available){
                if(variant.featured_image){
                    const thumbnail = document.querySelector(`.quick-view-gallery-thumbs [data-thumbnail-id="${variant.featured_image.id}"]`);
                    if(thumbnail){
                        swiper.slideTo(thumbnail.dataset.slide);
                    }
                }
            }

            // update button state (unit price x current quantity). Pass the fresh
            // variant since variants.currentVariant is not updated until after this event.
            updateAddToCartPrice(variant);

            // update price
            const price = $container.find('[data-regular-price]');
            price.html(Shopify.formatMoney(parseInt(variant.price)));
        }


        // init add to cart function 
        const productForm = $container.find('.product-form-js-quick-view');
        productForm.on("submit", function (evt) {
            evt.preventDefault();

            // A11Y: announce "Adding product to your cart" before the fetch.
            announceQuickAdd($container[0]);

            document.querySelector('[data-quick-modal]').classList.remove('opened');
            document.body.classList.remove('rebuy-modal-visible');

            theme.Product.prototype._addItemToCart(productForm[0]);
        });

        // init Rebuy vidget
        if($container.hasClass('quick-view_bundle') && window.Rebuy){
            Rebuy.init();
        }

        document.addEventListener('rebuy:cart.change', (event) => { 
            this.modal.classList.remove('opened');
            document.body.classList.remove('rebuy-modal-visible');
        });
          
    }
}
customElements.define('quick-view', QuickView);
